import { toast } from 'react-toastify'
import { getAllPolicies, getAllPolicyById } from '../../api/admin/policies'
import { getAllPolicyTracking } from '../../api/admin/tracking'
import {
  getSinglePolicy,
  policyDataInterface,
  policyResponse,
  policyResponseObject,
  trackingDataResponse,
  trackingResponse,
} from '../../utils/types'

export const getPolicyDataById = async (
  id: string | null,
  schoolId: string | null
): Promise<getSinglePolicy> => {
  console.log('sschoolId', schoolId)
  const response = (await getAllPolicyById(
    id,
    schoolId
  )) as policyResponseObject

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
export const getPolicyData = async (
  // currentPage: number,
  sortBy: string,
  sortOrderValue: string,
  data: string[]
): Promise<policyDataInterface> => {
  const response = (await getAllPolicies(
    // currentPage,
    sortBy,
    sortOrderValue,
    data
  )) as policyResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getTrackingData = async (
  // currentPage: number,
  sortBy: string,
  sortOrderValue: string
): Promise<trackingDataResponse> => {
  const response = (await getAllPolicyTracking(
    // currentPage,
    sortBy,
    sortOrderValue
  )) as trackingResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
